import _ from 'lodash';

import { TSchedule } from './RepaymentScheduleModal.reducer';

export function buildRepaymentScheduleState({
    schedule,
    summary
}: {
    schedule?: TSchedule['schedule'];
    summary?: TSchedule['summary'];
}) {
    const repayments = schedule ?? [];
    const totalPrincipal = summary?.total_credit_amount ?? 0;
    const totalRepayment = summary?.total_payable ?? 0;
    //TODO: These values should come from server side
    const totalInterest = _.reduce(
        repayments,
        (acc, repayment) => acc + repayment.interest,
        0
    );
    const totalFees = _.reduce(
        repayments,
        (acc, repayment) => acc + repayment.total_fees,
        0
    );

    const hasFees = totalFees > 0;

    return {
        repayments,
        totalPrincipal,
        totalInterest,
        totalRepayment,
        totalFees,
        hasFees
    };
}
